import React, { useEffect, useState, useRef } from 'react';
import { subscribeLoading } from '../api';

// A slim animated bar at the very top of the screen, shown automatically while
// any API request is in flight. A short delay prevents flicker on fast calls.
export default function GlobalLoader() {
  const [show, setShow] = useState(false);
  const timer = useRef(null);
  const shown = useRef(false);

  useEffect(() => subscribeLoading(on => {
    if (on) {
      if (shown.current || timer.current) return;
      timer.current = setTimeout(() => { shown.current = true; setShow(true); timer.current = null; }, 180);
    } else {
      if (timer.current) { clearTimeout(timer.current); timer.current = null; }
      shown.current = false;
      setShow(false);
    }
  }), []);

  if (!show) return null;
  return <div className="rp-loadbar"><div className="rp-loadbar-fill" /></div>;
}
